import type { Ref } from 'vue'
import { computed, ref, watch } from 'vue'
import type { TableData } from '../types'
export const useSelection = ({
  selection,
  allEnabledSelectionRows,
  emit
}: {
  selection: Ref<TableData[]>
  allEnabledSelectionRows: Ref<TableData[]>
  emit: any
}) => {
  const innerSelection = ref(selection.value ?? [])
  const keepSelection = computed(() => innerSelection.value.filter((row) => row.disabled))
  const selectionRows = computed(() => innerSelection.value)
  // todo 下一步启用
  const useSelectedKeys = ref<(string | number)[]>([])

  const toggleSelectAll = (checked: boolean) => {
    // console.log('keepSelection___', keepSelection.value)
    // console.log('LOG~~~~~~~~', allEnabledSelectionRows.value)
    const _allEnabledSelectionRows = [...allEnabledSelectionRows.value, ...keepSelection.value]
    // 全选，则用当前页中所有可选行，不含disabled，都则使用disabled行
    const _selection = checked ? _allEnabledSelectionRows : [...keepSelection.value]
    // console.log('useSelectedKeys', useSelectedKeys.value)
    // 下面要处理全选数据插入的问题，同时需要处理取消全选数据剔除的问题
    // 如果全选
    if (checked) {
      _selection.map((row) => {
        // 如果全部选中项中不包含当前页的数据，则插入
        if (!innerSelection.value.includes(row)) {
          innerSelection.value.push(row)
        }
      })
    } else {
      // 取消全选
      _allEnabledSelectionRows.map((row) => {
        if (innerSelection.value.includes(row)) {
          innerSelection.value = innerSelection.value.filter((r) => r !== row)
        }
      })
      _selection.map((row) => {
        if (!innerSelection.value.includes(row)) {
          innerSelection.value.push(row)
        }
      })
    }
    // TODO 没有绑定事件不需要触发事件函数
    emit('update:selection', innerSelection.value)
    emit('selection-change', innerSelection.value)

    // innerSelection.value = _selectedItems
  }

  /**
   * Table Checkbox全选
   * @param checked
   */
  const selectAll = (checked: boolean) => {
    // console.log('selectAll', checked)
    toggleSelectAll(checked)
    emit('select-all', checked)
  }

  watch(selection, (val) => {
    innerSelection.value = val
  })

  const toggleSelect = (row: TableData, checked: boolean) => {
    const originSelection = [...innerSelection.value]
    if (checked) {
      originSelection.push(row)
    } else {
      const index = originSelection.findIndex((r) => r === row)
      if (index > -1) {
        originSelection.splice(index, 1)
      }
    }
    innerSelection.value = originSelection

    emit('update:selection', originSelection)
    emit('selection-change', originSelection)
  }

  return {
    toggleSelect,
    toggleSelectAll,
    selectAll,
    selectionRows,
    useSelectedKeys
  }
}
